import React, { createContext, useState, useContext, useEffect } from 'react';

const AdminContext = createContext();

const ADMIN_CONFIG = {
  storageKey: 'real_estate_users_db',
  adminUser: 'admin',
  adminPassword: 'admin123'
};

// Estrutura inicial de usuários
const initialUsers = {
  'admin': {
    username: 'admin',
    password: 'admin123',
    role: 'admin',
    name: 'Administrador',
    template: 'real_estate', // template padrão
    createdAt: new Date().toISOString()
  },
  'corretor1': {
    username: 'corretor1',
    password: 'corretor123',
    role: 'user',
    name: 'Corretor 1',
    template: 'real_estate',
    company: 'Imobiliária Mara',
    createdAt: new Date().toISOString()
  },
  'corretor2': {
    username: 'corretor2',
    password: 'corretor123',
    role: 'user',
    name: 'Corretor 2',
    template: 'real_estate',
    company: 'Imobiliária Mara',
    createdAt: new Date().toISOString()
  },
  'ebes_solar': {
    username: 'ebes_solar',
    password: 'ebes123',
    role: 'user',
    name: 'EBES Solar',
    template: 'ebes_solar',
    company: 'EBES ENGENHARIA LTDA',
    cnpj: '02.277.320/0002-08',
    address: 'Av Guajajaras, loja 3, Jardim São Cristovão',
    city: 'São Luis',
    state: 'MA',
    cep: '65.056-045',
    createdAt: new Date().toISOString()
  }
};

export const AdminProvider = ({ children }) => {
  const [users, setUsers] = useState({});
  const [isAdmin, setIsAdmin] = useState(false);

  useEffect(() => {
    loadUsers();
  }, []);

  const loadUsers = () => {
    try {
      const storedUsers = localStorage.getItem(ADMIN_CONFIG.storageKey);
      if (storedUsers) {
        setUsers(JSON.parse(storedUsers));
      } else {
        // Primeira inicialização - salvar usuários padrão
        localStorage.setItem(ADMIN_CONFIG.storageKey, JSON.stringify(initialUsers));
        setUsers(initialUsers);
      }
    } catch (error) {
      console.error('Erro ao carregar usuários:', error);
      setUsers(initialUsers);
    }
  };

  const saveUsers = (updatedUsers) => {
    try {
      localStorage.setItem(ADMIN_CONFIG.storageKey, JSON.stringify(updatedUsers));
      setUsers(updatedUsers);
      return { success: true, message: 'Usuários atualizados com sucesso!' };
    } catch (error) {
      console.error('Erro ao salvar usuários:', error);
      return { success: false, message: 'Erro ao salvar usuários.' };
    }
  };

  const addUser = (userData) => {
    if (users[userData.username]) {
      return { success: false, message: 'Nome de usuário já existe.' };
    }

    const newUser = {
      ...userData,
      createdAt: new Date().toISOString()
    };

    const updatedUsers = {
      ...users,
      [userData.username]: newUser
    };

    return saveUsers(updatedUsers);
  };

  const updateUser = (username, userData) => {
    if (!users[username]) {
      return { success: false, message: 'Usuário não encontrado.' };
    }

    // Se o username foi alterado
    if (userData.username !== username) {
      if (users[userData.username]) {
        return { success: false, message: 'Novo nome de usuário já existe.' };
      }
      
      const updatedUsers = { ...users };
      delete updatedUsers[username];
      updatedUsers[userData.username] = {
        ...users[username],
        ...userData,
        updatedAt: new Date().toISOString()
      };
      
      return saveUsers(updatedUsers);
    }

    const updatedUsers = {
      ...users,
      [username]: {
        ...users[username],
        ...userData,
        updatedAt: new Date().toISOString()
      }
    };

    return saveUsers(updatedUsers);
  };

  const deleteUser = (username) => {
    if (username === 'admin') {
      return { success: false, message: 'Não é possível excluir o administrador.' };
    }

    if (!users[username]) {
      return { success: false, message: 'Usuário não encontrado.' };
    }

    const updatedUsers = { ...users };
    delete updatedUsers[username];

    return saveUsers(updatedUsers);
  };

  const getUserByUsername = (username) => {
    return users[username] || null;
  };

  const getAllUsers = () => {
    return Object.values(users).filter(user => user.role !== 'admin');
  };

  const checkIsAdmin = (username) => {
    const user = users[username];
    return user && user.role === 'admin';
  };

  const value = {
    users,
    isAdmin,
    setIsAdmin,
    addUser,
    updateUser,
    deleteUser,
    getUserByUsername,
    getAllUsers,
    checkIsAdmin,
    loadUsers
  };

  return (
    <AdminContext.Provider value={value}>
      {children}
    </AdminContext.Provider>
  );
};

export const useAdmin = () => {
  const context = useContext(AdminContext);
  
  if (!context) {
    throw new Error('useAdmin deve ser usado dentro de um AdminProvider');
  }
  
  return context;
};

export { AdminContext };